import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useCallback } from 'react'
import { Formik, Form, FastField } from 'formik'
import { MuiTextFieldFormik } from '../Formik'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ImpersonateLoginInput } from '@user/store/authorization/typings'
import {
  impersonateCodeCheck,
  impersonateLogin,
} from '@user/store/authorization/api'
import { updateLoadingState } from '@sales-center/common'
import { unwrapResult } from '@reduxjs/toolkit'
import { toast } from '@sales-center/components'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

const initialValues: ImpersonateLoginInput = {
  tempCode: '',
  email: '',
}

export const ImpersonationLogin: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const onSubmit = useCallback(
    async (model: ImpersonateLoginInput) => {
      dispatch(updateLoadingState('visible'))
      const checkResult = await dispatch(impersonateCodeCheck(model))

      if (impersonateCodeCheck.fulfilled.match(checkResult)) {
        model.email = checkResult.payload
        const result = await dispatch(impersonateLogin(model))
        dispatch(updateLoadingState('hidden'))

        if (impersonateLogin.fulfilled.match(result)) {
          navigate('/scdashboard')
        } else {
          try {
            unwrapResult(result)
          } catch (e) {
            if (e instanceof Error) toast.error(e.message)
            else if (typeof e === 'string') toast.error(e)
            else toast.error('Unexpected error')
          }
        }
      } else {
        try {
          unwrapResult(checkResult)
        } catch (e) {
          if (e instanceof Error) toast.error(e.message)
          else if (typeof e === 'string') toast.error(e)
          else toast.error('Unexpected error')
        }
      }
    },
    [dispatch, navigate],
  )
  const theme = useTheme()
  return (
    <Box display="flex" flexDirection="column" alignItems="center" padding={2}>
      <Typography variant="h3">User Impersonation</Typography>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        <Form
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: theme.spacing(1),
          }}
        >
          <FastField
            name="tempCode"
            label="Temp Code"
            component={MuiTextFieldFormik}
            required
          />

          <Button
            type="submit"
            color="primary"
            variant="contained"
            sx={{ marginTop: theme.spacing(1) }}
          >
            Log In
          </Button>
        </Form>
      </Formik>
    </Box>
  )
}
ImpersonationLogin.displayName = 'ImpersonationLogin'
